import { APP_CONTEXT_SUCCESS, APP_CONTEXT_REQUEST, APP_CONTEXT_FAILURE } from '../actions/app_context'

export function appContext(
  state = {
    isFetching: false,
    results: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case APP_CONTEXT_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }

    case APP_CONTEXT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        results: action.response,
      }
    case APP_CONTEXT_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error }
    default:
      return state
  }
}
